import { CheckCircle2, FileDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";

const previewItems = ["People who depend on you", "Current policies and beneficiaries", "Monthly budget comfort", "Questions you want Alicia to answer"];

export const ChecklistDownload = () => (
  <Reveal className="mb-14 overflow-hidden rounded-[2rem] bg-primary text-primary-foreground shadow-soft dark-grain relative" data-testid="family-checklist-download">
    <div className="relative z-10 grid gap-8 p-8 md:grid-cols-[1fr_auto] md:items-center md:p-12">
      <div>
        <p className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.28em] text-secondary">
          <FileDown size={16} /> Free family download
        </p>
        <h2 className="text-balance text-3xl tracking-tight md:text-5xl">Prepare for your first conversation with Alicia.</h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-primary-foreground/72">
          This printable checklist helps you gather the people, documents, questions, and goals that make a consultation more personal and productive.
        </p>
        <div className="mt-6 grid gap-3 sm:grid-cols-2">
          {previewItems.map((item, index) => (
            <div key={item} data-testid={`checklist-preview-${index + 1}`} className="flex items-center gap-3 text-sm text-primary-foreground/75">
              <CheckCircle2 size={17} className="shrink-0 text-secondary" /> {item}
            </div>
          ))}
        </div>
      </div>
      <Button asChild size="lg" className="rounded-full bg-secondary px-8 text-primary transition-[transform,background-color] duration-300 hover:-translate-y-1 hover:bg-secondary/90">
        <a href="/downloads/bello-joy-family-protection-checklist.pdf" download data-testid="download-family-checklist-button">
          Download the Checklist <FileDown size={17} />
        </a>
      </Button>
    </div>
  </Reveal>
);
